document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.m-faq-chat');

  if (!sections.length) return;

  sections.forEach((section) => {
    const items = section.querySelectorAll('.m-faq-chat__item--reveal');

    if (!items.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          });
        },
        {
          threshold: 0.18,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      items.forEach((item, index) => {
        item.style.transitionDelay = `${index * 120}ms`;
        observer.observe(item);
      });
    } else {
      items.forEach((item) => {
        item.classList.add('is-visible');
      });
    }
  });
});